import request from '../request'
const queryPageForMajor = data => request({
  url: '/memberMessage/queryPageForMajor',
  data,
  method: 'POST'
})
const insertForMajor = data => request({
  url: '/memberMessage/insertForMajor',
  data,
  method: 'POST'
})
const deleteByRowIds = params => request({
  url: '/memberMessage/deleteByRowIds',
  params
})
const queryDetailForMajorByRowId = params => request({
  url: '/memberMessage/queryDetailForMajorByRowId',
  params
})
const updateForMajor = data => request({
  url: '/memberMessage/updateForMajor',
  data,
  method: 'POST'
})
export default {
  queryPageForMajor,
  insertForMajor,
  deleteByRowIds,
  queryDetailForMajorByRowId,
  updateForMajor
}